export default "__VITE_ASSET__P2DKWNr2__"